/**
 * @ngdoc Controller
 * @name ProfileDealerController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('ProfileDealerController', ProfileDealerController);

    /**
     * @constructor
     * @ngInject
     */
    function ProfileDealerController($log, $scope, UserService) {
        $log.info('ProfileDealerController');

        $scope.forms = {};

        $scope.unlink = function(event) {
            // only continue
            if (!$scope.forms.unlinkForm.$valid) return;

            UserService
                .setDealer(null)
                .then(function(success) {
                    // Add action like
                    if (success) {
                        $scope.user.dealer = null;
                    }

                    return success;
                });
        };

        $scope.unlinkMyself = function(event) {
            // only continue
            if (!$scope.forms.unlinkMyselfForm.$valid) return;

            UserService
                .setDealer(null)
                .then(function(success) {
                    // Add action like
                    if (success) {
                        $scope.user.dealer = null;
                        $scope.reloadUser();
                    }

                    return success;
                });
        };

        $scope.linkModel = {
            dealerCode: null,
        };
        $scope.link = function(event) {
            // only continue
            if (!$scope.forms.linkForm.$valid) return;

            UserService
                .setDealer($scope.linkModel.dealerCode)
                .then(function(success) {
                    if (success) {
                        $scope.reloadUser();
                    }

                    return success;
                });
        };
    }

})();
